module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/190/assets/images/b271d2df57945515e355257e08e4c2c0.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_more.svg
// module id = c6zo
// module chunks = 1